<template>
  <div class="field-of-fields container" style="padding-bottom: 20vh; padding-top: 100px;">
    <!-- {{ listingID }} -->
    <div v-if="listing.id">
      <!-- {{ job }}
      <hr>
      {{ employer }} -->

      <div class="row pr-3">
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-4" style="max-width: 175px;" v-if="employer.profile_pic">
              <div v-if="employer.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/img/default_avatar.jpg'">
                <!-- {{ user.profile_pic }} -->
                <!-- https://stackoverflow.com/questions/37645243/static-image-src-in-vue-js-template -->
                <router-link :to="{ name: 'Employer Public Profile', params: { id: employer.id } }">
                  <img :src="employer.profile_pic" style="max-height: 150px; max-width: 150px;">
                </router-link>
              </div>
            </div>
            <div class="col-lg-8 my-auto">
              <h2 class="mt-2">{{ listing.title }}<span v-if="listing.event_type"> ({{ listing.event_type }})</span></h2>
              <h4 class="mt-2" v-if="employer.employer_name"><router-link :to="{ name: 'Employer Public Profile', params: { id: employer.id } }">{{ employer.employer_name }}</router-link></h4>
            </div>
          </div>

          <label v-if="listing.description" class="shaded-label">Description</label>
          <div class="profile-section">
            <pre class="" v-html="listing.description"></pre>
          </div>
        </div>
        <div class="col-lg-4 p-4" style="background-color: var(--bootstrapgrey)">
          <!-- <div v-if="listing.id && employer.id"> -->
          <div v-if="listing.id">
            <label v-if="listing.categories[0]" style="margin-top: 0;">Focus Areas:</label>
            <p v-if="listing.categories[0]">{{ listing.categories.join(', ') }}</p>
            <label v-if="listing.date">Date</label>
            <p v-if="listing.date">{{ new Date(listing.date.concat('T00:00:00')).toDateString() }}<span v-if="listing.end_date"> - {{ new Date(listing.end_date.concat('T00:00:00')).toDateString() }}</span></p>
            <p><span v-if="listing.start_time">{{ listing.start_time | trimSeconds }}</span><span v-if="listing.end_time"> - {{ listing.end_time | trimSeconds }}</span></p>
            <label v-if="listing.fee">Fee</label>
            <p v-if="listing.fee">{{ listing.fee }}</p>

            <hr v-if="listing.categories[0] || listing.fee || listing.date || listing.start_time">

            <p v-if="listing.city">{{ listing.city }}</p>
            <h4 v-if="listing.country">{{ listing.country }}</h4>
            <div>
              <small v-if="listing.address1" style="display: block;">{{ listing.address1 }}</small>
              <small v-if="listing.address2" style="display: block;">{{ listing.address2 }}</small>
              <small v-if="listing.postal_code" style="display: block;">{{ listing.postal_code }}</small>
            </div>

            <!-- <div v-if="listing.city" id='map' class="mt-2" style="height: 250px; width: 100%;"></div> -->
            <app-map v-if="listing.city" :locationObject="listing" class="mt-2"></app-map>

            <hr v-if="listing.city">

            <!-- <label v-if="employer.organization_type" style="margin-top: 0;">Organization Type</label>
            <p>{{ employer.organization_type }}</p>
            <label v-if="employer.size">Organization Size</label>
            <p>{{ employer.size }}</p>
            <span v-if="employer.id"><label v-if="employer.sectors[0]">Focus Areas</label></span>
            <ul>
              <li v-for="(sector, index) in employer.sectors" :key="'FocusAreas'+index">{{ sector }}</li>
            </ul>
            <hr v-if="employer.organization_type || employer.size || employer.sectors[0]"> -->

            <div v-if="listing.link" class="mt-4 mb-3">
              <a :href="listing.link" class="mylisting-button dark-button" target="_blank">EVENT PAGE</a>
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-if="listing.application_deadline || listing.link">
        <label class="shaded-label">Application</label>
        <div class="row profile-section">
          <div class="col-lg-4">
            <label v-if="listing.application_deadline">Application Deadline</label>
            <p>{{ new Date(listing.application_deadline).toDateString() }}</p>
          </div>
          <div class="col-lg-8">
            <label v-if="listing.link">Application Link</label>
          </div>
        </div>
      </div> -->

      <div v-if="(loggedinUser == employer.id) || $store.getters.isAgent == 'true'">
        <hr>
        <button class="mylisting-button danger-button" @click="deleteListing()">DELETE</button>
      </div>

    </div>
    <div v-if="!listing.id && !timeToLoad">
      <h2>Loading event...</h2>
    </div>
    <div v-if="!listing.id && timeToLoad">
      <h2>Sorry, event not found.</h2>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import router from '../../router'

  import Map from '../global/Map.vue';

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    data() {
      return {
        listingID: null,
        listing: {},
        employer: {},
        loggedinUser: null,

        timeToLoad: false,
      }
    },
    components: {
      appMap: Map,
    },
    created () {
      this.listingID = this.$route.params.id
      this.loggedinUser = this.$store.getters.userID
      this.getListing()

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
        this.timeToLoad = true
      },1000)
    },
    methods: {
      getListing() {
        axios.get('/api/events/'.concat(this.listingID.toString()))
          .then(res => {
            console.log(res.data)
            this.listing = res.data

            //Changes page title to match event title
            document.title = this.listing.title

            //Updates the URL to show the event listing title
            this.$router.replace({ name: 'Event', params: {id: this.listingID.toString()}, query: {title: this.listing.title.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,' ').trim().split(/\s+/).join('-')} })

            // axios.get('/api/people/'.concat(this.listing.poster.toString()))
            axios.get('/api/publicemployers/'.concat(this.listing.poster.toString()))
              .then(res => {
                console.log(res.data)
                this.employer = res.data
              })
              .catch(error => console.log(error))
          })
          .catch(error => console.log(error))
      },
      deleteListing() {
        // router.replace({name: 'Employer Dashboard'})
        axios.delete('/api/events/'.concat(this.listingID.toString()).concat('/'))
          .then(res => {
            console.log(res)
            // router.replace('/organization')
            router.replace({name: 'Employer Dashboard'})
          })
          .catch(error => console.log(error))
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/events/Event.vue